import { useMemo } from 'react';
import { noop } from 'js/utils/methods.util';

/**
 * Combine non-null handlers into one memoized handler
 * @param {Array<Function>} handlers
 * @returns {noop|*|(function(...[*]=))}
 */
export const useCombinedHandler = (handlers = []) => {
    const actualHandlers = handlers.filter(x => x != null);

    return useMemo(
        () => actualHandlers.length === 0
            ? noop
            : actualHandlers.length === 1
                ? actualHandlers[0]
                : (...args) => actualHandlers.forEach(handler => handler(...args)),
        [...actualHandlers] // eslint-disable-line react-hooks/exhaustive-deps
    );
};
